import { render, staticRenderFns } from "./CoreGroupbuyingsCreateOrEdit.vue?vue&type=template&id=4bf9c945&"
import script from "./CoreGroupbuyingsCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./CoreGroupbuyingsCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./CoreGroupbuyingsCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports